import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 0a12 12 0 1 0 12 12A12.014 12.014 0 0 0 12 0Zm0 3.958a4.826 4.826 0 1 1-4.826 4.826A4.828 4.828 0 0 1 12 3.958Zm0 18.857a10.79 10.79 0 0 1-8.156-3.724l.292-.971a4.827 4.827 0 0 1 4.622-3.439h6.485a4.827 4.827 0 0 1 4.622 3.439l.292.971A10.79 10.79 0 0 1 12 22.815Z"
    }, null, -1)
  ])))
}
export default { render: render }